<script>
import { required } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
import { cloneDeep } from "lodash";
import RawData from "@/components/widgets/raw-data.vue";
export default {
    name: 'SubmissionTab',
    components: {
        DatePicker,
        RawData
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        selectedRecanvasRfq: {
            type: Number,
            default: 0
        },
        cartItems: {
            type: Array,
            default: () => []
        },
        mop: {
            type: Array,
            default: () => []
        },
        recanvases: {
            type: Array,
            default: () => []
        },
        cartBusy: {
            type: Boolean,
            default: false
        },
        cartCount: {
            type: Number,
            default: 0
        },
        rfq: {
            type: Object,
            default: () => {
                return {
                    id: 0,
                    description: "",
                    tracking: "",
                    modeOfProcurementId: "",
                    deliveryTerms: "",
                    paymentTerms: "",
                    deliveryPeriod: "",
                    deadline: "",
                    supplierIds: [],
                    cycle: "",
                    dateSubmitted: "",
                    note: "",
                }
            }
        },
        selectedSupplier: {
            type: Array,
            default: () => []
        }
    },
    data(){
        return {
            pageOptions: [10, 25, 50, 100],
            filterCartItems: '',
            perPageItem: 10,
            currentPageItem: 1,
            submitted: false,
            cartVariables: {},
        }
    },
    validations: {
        rfq: {
            description: { required },
            tracking: { required },
            modeOfProcurementId: { required },
            deadline: { required },
            dateSubmitted: { required },
        },
        selectedSupplier: { required },
    },
    computed: {
        selectedRfqId: {
            get(){
                return this.selectedRecanvasRfq;
            },
            set(val){
                this.$emit('changeRfq', val);
            }
        },
        filteredCartItems() {
            let data = this.cartItems;
            var total = this.currentPageItem * this.perPageItem;
            if (this.filterCartItems.trim() != "" && this.filterCartItems) {
                data = data.filter((item) => {
                    return item.itemName
                        .toUpperCase()
                        .includes(this.filterCartItems.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPageItem, total);
            if (this.currentPageItem > 1 && currentData.length == 0) {
                total = (this.currentPageItem - 1) * this.perPageItem;
                currentData = data.slice(total - this.perPageItem, total);
            }
            return currentData;
        },
        rowsCartItems() {
            if (this.filterCartItems.trim() != "" && this.filterCartItems) {
                return this.filteredCartItems.length;
            } else {
                return this.cartItems.length;
            }
        },
    },
    methods: {
        openPopOver(x) {
            x.editQty = true;
            this.cartVariables = cloneDeep(x);
        },
        totalCartAmt() {
            return this.cartItems.reduce((pv, cv) => {
                return pv + parseFloat(cv.total) + parseFloat(cv.adjustmentCost || 0);
            }, 0);
        },
        getSuppliers(){
            let type = 'recanvas';
            if(this.recanvases.length == 0){
                type = 'rfq';
            }
            this.$emit('getSuppliers', type);
        },
        removeSupplier(index){
            this.$emit('removeSupplier', index);
        },
        checkOut(){
            this.submitted = true;
            this.$v.rfq.$touch();
            if (this.$v.rfq.$invalid) {
                return;
            }
            this.$v.selectedSupplier.$touch();
            if (this.$v.selectedSupplier.$invalid) {
                return;
            }
            if (this.cartItems.length == 0) {
                return this.showToast("Please add items to cart!", "warning");
            }
            var data = cloneDeep(this.rfq);
            data.supplierIds = [];
            this.selectedSupplier.forEach((item) => {
                data.supplierIds.push(item.id);
            });
            // data.deliveryPeriod = this.getExactAmt(this.rfq.deliveryPeriod);
            data.deadline = this.getDate(this.rfq.deadline);
            data.dateSubmitted = this.getDate(this.rfq.dateSubmitted);
            if(this.title === 'Recanvass Form'){
                data.type = 'recanvas';
            }else{
                data.type = 'rfq';
            }
            this.$emit('checkOut', data);
        },
        cancelPR(){
            let data = {
                id: this.rfq.id,
                type: this.title === 'Bids/RFQ Form' ? 'rfq' : 'recanvas'
            }
            this.$emit('cancelPR', data);
        },
        getResourceInfo(id){
            this.$emit('getResourceInfo', id);
        },
        hidePopOver(x) {
            x.editQty = false;
        },
        onShownPopOver(x) {
            this.focusRef(this.$refs[`po-${x.id}`][0]);
        },
        onShownRFQItems(x) {
            this.focusRef(this.$refs[`rfq-${x.id}`][0]);
        },
        focusRef(ref) {
            this.$nextTick(() => {
                this.$nextTick(() => {
                    (ref.$el || ref).focus();
                });
            });
        },
    }
}
</script>
<template>
    <div class="row">
        <div class="col-xl-8">
            <div class="card">
                <div class="card-body">
                    <div class="row mb-2">
                        <div class="col-md-6">
                            <h5 class="mb-0">{{title}}</h5>
                            <small
                                >List of items in purchase
                                request</small
                            >
                        </div>
                        <div
                            class="
                                col-md-6
                                d-flex
                                justify-content-end
                            "
                        >
                            <div
                                id="tickets-table_filter"
                                class="dataTables_filter me-1"
                            >
                                <label
                                    class="
                                        d-inline-flex
                                        align-items-center
                                    "
                                >
                                    <b-form-input
                                        autocomplete="off"
                                        v-model="filterCartItems"
                                        type="search"
                                        placeholder="Search Items..."
                                        class="form-control"
                                    ></b-form-input>
                                </label>
                            </div>
                            <div
                                id="tickets-table_length"
                                class="dataTables_length"
                            >
                                <label
                                    class="
                                        d-inline-flex
                                        align-items-center
                                        mb-0
                                    "
                                >
                                    <b-form-select
                                        class="form-select"
                                        v-model="perPageItem"
                                        size="sm"
                                        :options="pageOptions"
                                    ></b-form-select>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table class="table align-middle mb-0">
                            <thead class="table-light">
                                <tr>
                                    <th>Product Desc</th>
                                    <th width="150px">Price</th>
                                    <th width="150px">Quantity</th>
                                    <th colspan="2">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template
                                    v-if="
                                        filteredCartItems.length >
                                            0 && !cartBusy
                                    "
                                >
                                    <tr
                                        v-for="x in filteredCartItems"
                                        :key="x.id"
                                    >
                                        <td class="position-relative">
                                            <RawData 
                                                :data="x" 
                                                v-if="$store.state.decrypt.isAdmin()" 
                                                placement="left"
                                            />
                                            <div>
                                                <h5
                                                    class="
                                                        font-size-14
                                                        mb-0
                                                        me-1
                                                        d-inline
                                                    "
                                                >
                                                    <span
                                                        class="
                                                            text-dark
                                                        "
                                                        >{{
                                                            x.itemName
                                                        }}</span
                                                    >
                                                </h5>
                                                <a href="javascript:void(0);" class="mb-0" @click="getResourceInfo(x.apiResourceId)"><i class="bx bx-info-circle"></i></a>
                                            </div>
                                            <p class="mb-0">
                                                <small>{{
                                                    x.description
                                                }}</small>
                                            </p>
                                        </td>
                                        <td>
                                            {{
                                                formatCurrency(
                                                    x.unitCost
                                                )
                                            }}
                                        </td>
                                        <td>
                                            <span
                                                @click="
                                                    openPopOver(x)
                                                "
                                                class="
                                                    form-control
                                                    cursor-pointer
                                                "
                                                :id="`editQ-${x.id}`"
                                                >{{
                                                    x.quantity
                                                }}</span
                                            >
                                            <b-popover
                                                :show.sync="
                                                    x.editQty
                                                "
                                                :target="`editQ-${x.id}`"
                                                triggers="click blur"
                                                placement="leftbottom"
                                                @shown="
                                                    onShownPopOver(
                                                        x
                                                    )
                                                "
                                            >
                                                <template
                                                    v-slot:title
                                                >
                                                    <div
                                                        class="
                                                            d-flex
                                                            align-items-center
                                                            justify-content-between
                                                        "
                                                    >
                                                        <small
                                                            >Quantity
                                                        </small>
                                                        <button
                                                            type="button"
                                                            class="
                                                                bx
                                                                bx-x
                                                                font-size-14
                                                                cursor-pointer
                                                                border-0
                                                                bg-clear
                                                            "
                                                            @click="
                                                                hidePopOver(
                                                                    x
                                                                )
                                                            "
                                                            :ref="`po-${x.id}`"
                                                        ></button>
                                                    </div>
                                                </template>
                                                <div class="mb-3">
                                                    <div
                                                        class="
                                                            d-flex
                                                        "
                                                    >
                                                        <div
                                                            class="
                                                                mx-2
                                                            "
                                                        >
                                                            <small
                                                                >January</small
                                                            >
                                                            <div>
                                                                <input
                                                                    type="text"
                                                                    class="
                                                                        form-control
                                                                        form-control-sm
                                                                    "
                                                                    v-model="
                                                                        cartVariables.JanValue
                                                                    "
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="
                                                                mx-2
                                                            "
                                                        >
                                                            <small
                                                                >February</small
                                                            >
                                                            <div>
                                                                <input
                                                                    type="text"
                                                                    class="
                                                                        form-control
                                                                        form-control-sm
                                                                    "
                                                                    v-model="
                                                                        cartVariables.FebValue
                                                                    "
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="
                                                                mx-2
                                                            "
                                                        >
                                                            <small
                                                                >March</small
                                                            >
                                                            <div>
                                                                <input
                                                                    type="text"
                                                                    class="
                                                                        form-control
                                                                        form-control-sm
                                                                    "
                                                                    v-model="
                                                                        cartVariables.MarValue
                                                                    "
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="
                                                            d-flex
                                                            mt-1
                                                        "
                                                    >
                                                        <div
                                                            class="
                                                                mx-2
                                                            "
                                                        >
                                                            <small
                                                                >April</small
                                                            >
                                                            <div>
                                                                <input
                                                                    type="text"
                                                                    class="
                                                                        form-control
                                                                        form-control-sm
                                                                    "
                                                                    v-model="
                                                                        cartVariables.AprValue
                                                                    "
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="
                                                                mx-2
                                                            "
                                                        >
                                                            <small
                                                                >May</small
                                                            >
                                                            <div>
                                                                <input
                                                                    type="text"
                                                                    class="
                                                                        form-control
                                                                        form-control-sm
                                                                    "
                                                                    v-model="
                                                                        cartVariables.MayValue
                                                                    "
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="
                                                                mx-2
                                                            "
                                                        >
                                                            <small
                                                                >June</small
                                                            >
                                                            <div>
                                                                <input
                                                                    type="text"
                                                                    class="
                                                                        form-control
                                                                        form-control-sm
                                                                    "
                                                                    v-model="
                                                                        cartVariables.JuneValue
                                                                    "
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="
                                                            d-flex
                                                            mt-1
                                                        "
                                                    >
                                                        <div
                                                            class="
                                                                mx-2
                                                            "
                                                        >
                                                            <small
                                                                >July</small
                                                            >
                                                            <div>
                                                                <input
                                                                    type="text"
                                                                    class="
                                                                        form-control
                                                                        form-control-sm
                                                                    "
                                                                    v-model="
                                                                        cartVariables.JulyValue
                                                                    "
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="
                                                                mx-2
                                                            "
                                                        >
                                                            <small
                                                                >August</small
                                                            >
                                                            <div>
                                                                <input
                                                                    type="text"
                                                                    class="
                                                                        form-control
                                                                        form-control-sm
                                                                    "
                                                                    v-model="
                                                                        cartVariables.AugValue
                                                                    "
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="
                                                                mx-2
                                                            "
                                                        >
                                                            <small
                                                                >September</small
                                                            >
                                                            <div>
                                                                <input
                                                                    type="text"
                                                                    class="
                                                                        form-control
                                                                        form-control-sm
                                                                    "
                                                                    v-model="
                                                                        cartVariables.SepValue
                                                                    "
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="
                                                            d-flex
                                                            mt-1
                                                        "
                                                    >
                                                        <div
                                                            class="
                                                                mx-2
                                                            "
                                                        >
                                                            <small
                                                                >October</small
                                                            >
                                                            <div>
                                                                <input
                                                                    type="text"
                                                                    class="
                                                                        form-control
                                                                        form-control-sm
                                                                    "
                                                                    v-model="
                                                                        cartVariables.OctValue
                                                                    "
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="
                                                                mx-2
                                                            "
                                                        >
                                                            <small
                                                                >November</small
                                                            >
                                                            <div>
                                                                <input
                                                                    type="text"
                                                                    class="
                                                                        form-control
                                                                        form-control-sm
                                                                    "
                                                                    v-model="
                                                                        cartVariables.NovValue
                                                                    "
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="
                                                                mx-2
                                                            "
                                                        >
                                                            <small
                                                                >December</small
                                                            >
                                                            <div>
                                                                <input
                                                                    type="text"
                                                                    class="
                                                                        form-control
                                                                        form-control-sm
                                                                    "
                                                                    v-model="
                                                                        cartVariables.DecValue
                                                                    "
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-popover>
                                        </td>
                                        <td>
                                            {{
                                                formatCurrency(x.total)
                                            }}
                                        </td>
                                        <!-- <td style="width: 70px">
                                            <a
                                                href="javascript:void(0);"
                                                class="
                                                    action-icon
                                                    text-danger
                                                "
                                                @click="
                                                    deleteCartItem(
                                                        x
                                                    )
                                                "
                                                ><i
                                                    class="
                                                        mdi
                                                        mdi-trash-can
                                                        font-size-18
                                                    "
                                                ></i
                                            ></a>
                                        </td> -->
                                    </tr>
                                    <tr>
                                        <td
                                            colspan="3"
                                            class="text-right"
                                        >
                                            <h5 class="mb-0">
                                                Grand Total:
                                            </h5>
                                        </td>
                                        <td>
                                            {{
                                                formatCurrency(
                                                    totalCartAmt()
                                                )
                                            }}
                                        </td>
                                    </tr>
                                </template>
                                <tr
                                    v-if="
                                        filteredCartItems.length ==
                                            0 &&
                                        filterCartItems &&
                                        !cartBusy
                                    "
                                >
                                    <td
                                        colspan="5"
                                        class="text-center"
                                    >
                                        Search not found
                                    </td>
                                </tr>
                                <tr
                                    v-if="
                                        filteredCartItems.length ==
                                            0 &&
                                        !filterCartItems &&
                                        !cartBusy
                                    "
                                >
                                    <td
                                        colspan="5"
                                        class="text-center"
                                    >
                                        No Cart Items found
                                    </td>
                                </tr>
                                <tr v-if="cartBusy">
                                    <td
                                        colspan="5"
                                        class="text-center"
                                    >
                                        <div
                                            class="
                                                d-flex
                                                justify-content-center
                                                align-items-center
                                            "
                                        >
                                            <div
                                                class="
                                                    preloader-component
                                                    me-2
                                                "
                                            >
                                                <div class="status">
                                                    <div
                                                        class="
                                                            spinner-chase
                                                            w-20px
                                                            h-20px
                                                        "
                                                    >
                                                        <div
                                                            class="
                                                                chase-dot
                                                            "
                                                        ></div>
                                                        <div
                                                            class="
                                                                chase-dot
                                                            "
                                                        ></div>
                                                        <div
                                                            class="
                                                                chase-dot
                                                            "
                                                        ></div>
                                                        <div
                                                            class="
                                                                chase-dot
                                                            "
                                                        ></div>
                                                        <div
                                                            class="
                                                                chase-dot
                                                            "
                                                        ></div>
                                                        <div
                                                            class="
                                                                chase-dot
                                                            "
                                                        ></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <strong
                                                >Loading...</strong
                                            >
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="row mt-4 mb-2 align-items-center">
                        <div class="col-6">
                            <button
                                type="button"
                                class="btn btn-outline-warning"
                                @click="cancelPR()"
                                v-if="cartCount > 0"
                            >
                                <i class="bx bx-x"></i> Cancel this
                                {{title === 'Bids/RFQ Form' ?  'P.R' : 'Recanvass'}}
                            </button>
                        </div>
                        <div class="col-6 mb-1">
                            <div
                                class="
                                    dataTables_paginate
                                    paging_simple_numbers
                                    float-end
                                "
                            >
                                <ul
                                    class="
                                        pagination
                                        pagination-rounded
                                        mb-0
                                    "
                                >
                                    <!-- pagination -->
                                    <b-pagination
                                        v-model="currentPageItem"
                                        :total-rows="rowsCartItems"
                                        :per-page="perPageItem"
                                    ></b-pagination>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-4">
            <form @submit.prevent="checkOut">
                <div class="card">
                    <RawData 
                        :data="rfq" 
                        v-if="$store.state.decrypt.isAdmin()" 
                        placement="left"
                    />
                    <div class="card-body">
                        <div class="mb-4 d-flex align-items-center justify-content-between">
                            <h5 class="card-title">
                                Bids/RFQ Details
                            </h5>
                            <button
                                type="submit"
                                class="btn btn-success"
                            >
                                <i
                                    class="
                                        mdi mdi-check
                                        me-1
                                    "
                                ></i>
                                Submit
                            </button>
                        </div>
                        <div class="mb-3" v-if="title === 'Recanvass Form'">
                            <div class="d-flex align-items-center">
                                <span class="no-wrap me-2">RFQ No.:</span>
                                <select class="form-select" v-model="selectedRfqId">
                                    <option value="0"></option>
                                    <option
                                        v-for="x in recanvases"
                                        :value="x.id"
                                        :key="x.id"
                                        >{{ x.rfqNumber }}</option
                                    >
                                </select>
                            </div>
                        </div>
                        <div class="mb-3">
                            <textarea
                                rows="2"
                                placeholder="RFQ Description"
                                class="form-control text-warning"
                                v-model="rfq.description"
                                :class="{
                                    'is-invalid':
                                        submitted &&
                                        $v.rfq.description.$error,
                                }"
                            >
                            </textarea>
                            <div
                                v-if="
                                    submitted &&
                                    $v.rfq.description.$error
                                "
                                class="invalid-feedback"
                            >
                                <span
                                    v-if="
                                        !$v.rfq.description.required
                                    "
                                    >This value is required.</span
                                >
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="modeOfProcurementId"
                                >Mode of Procurement
                            </label>
                            <b-form-select
                                class="form-select"
                                v-model="rfq.modeOfProcurementId"
                                size="sm"
                                :options="mop"
                                :class="{
                                    'is-invalid':
                                        submitted &&
                                        $v.rfq.modeOfProcurementId
                                            .$error,
                                }"
                            ></b-form-select>
                            <div
                                v-if="
                                    submitted &&
                                    $v.rfq.modeOfProcurementId
                                        .$error
                                "
                                class="invalid-feedback"
                            >
                                <span
                                    v-if="
                                        !$v.rfq.modeOfProcurementId
                                            .required
                                    "
                                    >This value is required.</span
                                >
                            </div>
                        </div>
                        <b-row class="mb-3">
                            <b-col>
                                <label for="tracking"
                                    >Tracking Number
                                </label>
                                <input
                                    id="tracking"
                                    type="text"
                                    v-model="rfq.tracking"
                                    placeholder="Enter Tracking Number..."
                                    class="form-control text-warning"
                                    :class="{
                                        'is-invalid':
                                            submitted &&
                                            $v.rfq.tracking.$error,
                                    }"
                                    autocomplete="off"
                                />
                                <div
                                    v-if="
                                        submitted &&
                                        $v.rfq.tracking.$error
                                    "
                                    class="invalid-feedback"
                                >
                                    <span
                                        v-if="
                                            !$v.rfq.tracking
                                                .required
                                        "
                                        >This value is
                                        required.</span
                                    >
                                </div>
                            </b-col>
                        </b-row>
                        <b-row class="mb-3">
                            <b-col>
                                <b-col>
                                    <label for="dateSubmitted"
                                        >Bids/RFQ Date
                                    </label>
                                    <date-picker
                                        v-model="rfq.dateSubmitted"
                                        :first-day-of-week="1"
                                        lang="en"
                                        placeholder="Enter Bids/RFQ Date..."
                                        :class="{
                                            'is-invalid':
                                                submitted &&
                                                $v.rfq.dateSubmitted.$error,
                                        }"
                                        input-class="text-warning form-control"
                                    ></date-picker>
                                    <div
                                        v-if="
                                            submitted &&
                                            $v.rfq.dateSubmitted.$error
                                        "
                                        class="invalid-feedback"
                                    >
                                        <span
                                            v-if="
                                                !$v.rfq.dateSubmitted
                                                    .required
                                            "
                                            >This value is required.</span
                                        >
                                    </div>
                                </b-col>
                            </b-col>
                            <b-col>
                                <label for="deadline"
                                    >Bids/RFQ Deadline
                                </label>
                                <date-picker
                                    v-model="rfq.deadline"
                                    :first-day-of-week="1"
                                    lang="en"
                                    placeholder="Enter Bids/RFQ Deadline..."
                                    :class="{
                                        'is-invalid':
                                            submitted &&
                                            $v.rfq.deadline.$error,
                                    }"
                                    input-class="text-warning form-control"
                                ></date-picker>
                                <div
                                    v-if="
                                        submitted &&
                                        $v.rfq.deadline.$error
                                    "
                                    class="invalid-feedback"
                                >
                                    <span
                                        v-if="
                                            !$v.rfq.deadline
                                                .required
                                        "
                                        >This value is
                                        required.</span
                                    >
                                </div>
                            </b-col>
                        </b-row>
                        <div class="mb-3">
                            <div
                                class="
                                    d-flex
                                    align-items-center
                                    justify-content-between
                                    mb-2
                                "
                            >
                                <label for="deadline" class="mb-0"
                                    >Supplier/Provider
                                </label>
                                <button
                                    type="button"
                                    class="
                                        btn
                                        btn-sm
                                        btn-outline-warning
                                        no-wrap
                                    "
                                    @click="getSuppliers()"
                                >
                                    <i class="bx bx-plus me-1"></i
                                    >Add Suppliers/Providers
                                </button>
                            </div>
                            <div
                                class="multiselect__tags warning"
                                :class="{
                                    'is-invalid':
                                        submitted &&
                                        $v.selectedSupplier.$error,
                                }"
                            >
                                <div class="multiselect__tags-wrap">
                                    <span
                                        class="multiselect__tag"
                                        v-for="(
                                            supplier, index
                                        ) in selectedSupplier"
                                        :key="supplier.id"
                                    >
                                        <span>{{
                                            supplier.name
                                        }}</span>
                                        <i
                                            class="
                                                multiselect__tag-icon
                                            "
                                            @click="
                                                removeSupplier(
                                                    index
                                                )
                                            "
                                        ></i
                                    ></span>
                                </div>
                            </div>
                            <div
                                v-if="
                                    submitted &&
                                    $v.selectedSupplier.$error
                                "
                                class="invalid-feedback"
                            >
                                <span
                                    v-if="
                                        !$v.selectedSupplier
                                            .required
                                    "
                                    >This value is required.</span
                                >
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="rfqNote">Notes</label>
                            <textarea
                                name="note"
                                id="rfqNote"
                                rows="2"
                                placeholder="Enter Notes"
                                class="form-control text-warning"
                                v-model="rfq.note"
                            ></textarea>
                        </div>
                        <div v-if="cartCount > 0">
                            <b>Purchase Request Details</b>
                            <ul class="px-3">
                                <li>Mode of Procurement: <span class="text-warning">{{rfq.modeOfProcurement}}</span></li>
                                <li>Payment Terms: <span class="text-warning">{{rfq.paymentTerms}}</span></li>
                                <li>Delivery Terms: <span class="text-warning">{{rfq.deliveryTerms}}</span></li>
                                <li>Delivery Period: <span class="text-warning">{{rfq.deliveryPeriod}} calendar days</span></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>